import { render, staticRenderFns } from "./ChartComponentG2.vue?vue&type=template&id=b3e5ecd6&"
import script from "./ChartComponentG2.vue?vue&type=script&lang=js&"
export * from "./ChartComponentG2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports